import { TypeSafeDynamicModalRef } from './type-safe-dynamic-modal-ref';

export abstract class ModalBase<T = null, R = void> {
	data: T;
	dynamicModalRef: TypeSafeDynamicModalRef<R>;
}
